import type { Status } from '../types';
import { STATUS_LABELS } from '../types';

const GLYPH: Record<Status, string> = {
  healthy: '✓',
  warning: '⚠',
  failed: '✕',
  paused: '⏸',
  unknown: '?',
};

/**
 * The `reason` tooltip is not decoration. Half the original complaint was "I
 * cannot tell why this is amber", so every pill carries its justification.
 */
export function StatusPill({ status, reason }: { status: Status; reason?: string | null }) {
  return (
    <span className={`pill pill-${status}`} title={reason ?? undefined}>
      <span className="pill-dot" aria-hidden="true" />
      {GLYPH[status]} {STATUS_LABELS[status]}
    </span>
  );
}
